// extracted by mini-css-extract-plugin
export default {"directionRules":"ForbiddenRelations_directionRules__cqD34","inline":"ForbiddenRelations_inline__jwIGp","error":"ForbiddenRelations_error__gX--x"};